<div class="step-container registration-success-page">
  <div class="registration-content">
    <h5 class="registration-success-page-title text-success">
      {{ 'fgbcl.registration.success.page.title' | translate: { fgbdefault: 'Processed Successfully' } }}
    </h5>
    <p class="mb-0">{{ 'register.success.greeting' | translate }}</p>
    <p class="mb-3" [innerHtml]="'register.success.successfully.registered' | translate | markdownTranslate"></p>
    <p class="mb-3" [innerHtml]="'register.success.message' | translate | markdownTranslate"></p>
    <p class="mb-3" [innerHtml]="'register.success.instruction' | translate | markdownTranslate"></p>
    <a class="btn back-btn fw-bold" [routerLink]="['/guardians']">{{
      'fgbcl.registration.success.page.back.button' | translate
    }}</a>
  </div>

  <ng-template #defaultMessage>
    <p class="message">
      {{ 'fgbcl.registration.success.page.account.message' | translate
      }}<em>{{ 'fgbcl.registration.success.page.account.instruction' | translate }}</em>
    </p>
    <a class="btn back-btn" [routerLink]="['/']">{{ 'fgbcl.registration.success.page.login.button' | translate }}</a>
  </ng-template>
</div>

<!-- LOADING SPINNER  -->
<ng-template #loading>
  <div class="text-center p-4">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
